// import { Tooltip as ReactTooltip } from 'react-tooltip'

import Spark from 'app/assets/icons/SmartDocs/Spark.svg'
import { Box, Flex } from 'app/components/design-system-components'
import { ToolTip } from 'app/components/design-system-components/Tooltip'
import * as Display from 'app/components/display/display'
import UpgradeCTAFromSetting from 'app/components/display/smartdocs/upgradeCTAs/fromSetting'
import * as Form from 'app/components/forms/forms'
import theme from 'app/match/applicationReportPDF/assets/theme'
import GeneralBottomBtns from 'app/shared_components/general_bottom_btn/component'
import { NEXT_GEN_LEASING_URL } from 'app/utils/text/helpers'

function AIToolsTab({
  isAccountLite = false,
  isActionDisabled = false,
  smartDocsForRenters,
  smartDocsForTeam,
  copilotEnabled,
  onClickSmartDocsForRenters,
  onClickSmartDocsForTeam,
  onClickCopilotEnabled,
  onBackButtonClicked,
  onConfirmButtonClicked,
}) {
  return (
    <>
      <Display.MainHeader
        hasSeperator={false}
        text={
          <Flex>
            <Box mr={3}>AI Tools (Beta)</Box>
            <img src={Spark} width={theme.width[7] + 'px'} alt="ai tools" />
          </Flex>
        }
        textClass="p0"
        componentClass="mb0"
      />

      <Display.DefaultBodyText>
        <p className="mb0 mt8">
          Enable Next Gen Leasing and benefit from faster application processing
          and improved accuracy.{' '}
          <a href={NEXT_GEN_LEASING_URL} target="_blank" rel="noreferrer">
            learn more
          </a>
        </p>
      </Display.DefaultBodyText>
      <Box mt={5}>
        {isAccountLite && <UpgradeCTAFromSetting />}

        <Flex alignItems="center">
          <Form.CheckBoxGeneral
            id="disableViewingTip"
            label="SmartDocs (Renter)"
            checked={smartDocsForRenters}
            onChange={onClickSmartDocsForRenters}
            componentClassName="mt10"
            eventProcessedByComponent
          />
          <ToolTip
            content="Enable SmartDoc processing for applicants. SmartDocs helps verify information supplied in Payslips and Rental Ledgers."
            toolTipID="smartDocsForRenters"
          />
        </Flex>

        <Flex alignItems="center">
          <Form.CheckBoxGeneral
            id="disableViewingTip"
            label="SmartDocs (Team)"
            checked={smartDocsForTeam}
            onChange={onClickSmartDocsForTeam}
            componentClassName="mt10"
            eventProcessedByComponent
            disabled={isActionDisabled}
            showDisabledGrey={isActionDisabled}
          />
          <ToolTip
            content="Enable SmartDoc processing for the team. SmartDocs helps verify information supplied in Payslips and Rental Ledgers."
            toolTipID="smartDocsForTeam"
          />
        </Flex>

        <Flex alignItems="center">
          <Form.CheckBoxGeneral
            id="disableViewingTip"
            label="Copilot"
            checked={copilotEnabled}
            onChange={onClickCopilotEnabled}
            componentClassName="mt10"
            eventProcessedByComponent
            disabled={isActionDisabled}
            showDisabledGrey={isActionDisabled}
          />
          <ToolTip
            content="Enable Copilot for application processing. Copilot provides insights and suggests actions."
            toolTipID="copilotEnabled"
          />
        </Flex>

        <Box className="pdf-hide">
          <GeneralBottomBtns
            onBackButtonClicked={onBackButtonClicked}
            onConfirmButtonClicked={onConfirmButtonClicked}
            confirmBtnText={'Update'}
          />
        </Box>
      </Box>
    </>
  )
}

export default AIToolsTab
